// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"b247284f","984":"c3c8db2e"}[chunkId] + ".chunk.js";
};